var render = function () {
  var _vm$singleRideData, _vm$singleRideData2, _vm$singleRideData3, _vm$singleRideData4, _vm$singleRideData5, _vm$singleRideData6, _vm$riderData, _vm$riderData$user, _vm$riderData2, _vm$riderData2$user, _vm$riderData3, _vm$riderData3$user, _vm$singleRideData7, _vm$singleRideData8, _vm$singleRideData9, _vm$singleRideData0, _vm$singleRideData1, _vm$singleRideData10;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "activeRaceClub container"
  }, [_c('div', {
    staticClass: "day-selected"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.selectedDate, "DD/MM/YYYY")))]), _c('h4', [_c('span', {
    staticClass: "txtClrSkyBlue"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('hide-detail');
      }
    }
  }, [_vm._v("ACTIVITIES/")])]), _c('span', {
    staticClass: "txtClrwt"
  }, [_vm._v(_vm._s((_vm$singleRideData = _vm.singleRideData) === null || _vm$singleRideData === void 0 ? void 0 : _vm$singleRideData.header_detail["title"]) + " |")]), _c('span', {
    staticClass: "txtfontNormal"
  }, [_vm._v(_vm._s((_vm$singleRideData2 = _vm.singleRideData) === null || _vm$singleRideData2 === void 0 ? void 0 : _vm$singleRideData2.header_detail["routeName"]))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-6"
  }, [_c('div', {
    staticClass: "player-moniter d-flex justify-content-between align-items-end"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Normalize Power")]), _c('div', [_c('span', {
    staticClass: "num-count"
  }, [_vm._v(_vm._s((_vm$singleRideData3 = _vm.singleRideData) === null || _vm$singleRideData3 === void 0 ? void 0 : _vm$singleRideData3.header_detail["normalizePower"]) + " w")])])]), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("TOTAL WORK")]), _c('div', [_c('span', {
    staticClass: "num-count"
  }, [_vm._v(_vm._s((_vm$singleRideData4 = _vm.singleRideData) === null || _vm$singleRideData4 === void 0 ? void 0 : _vm$singleRideData4.header_detail["totalWorkout"]) + " kj")])])]), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("TRAINING LOAD")]), _c('div', [_c('span', {
    staticClass: "num-count"
  }, [_vm._v(_vm._s((_vm$singleRideData5 = _vm.singleRideData) === null || _vm$singleRideData5 === void 0 ? void 0 : _vm$singleRideData5.header_detail["traningLoad"]))])])]), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("INTENSITY")]), _c('div', [_c('span', {
    staticClass: "num-count"
  }, [_vm._v(_vm._s((_vm$singleRideData6 = _vm.singleRideData) === null || _vm$singleRideData6 === void 0 ? void 0 : _vm$singleRideData6.header_detail["intensity"]) + "%")])])])])]), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-6"
  }, [_c('div', {
    staticClass: "btn-rece d-flex justify-content-end align-items-end"
  }, [_c('a', {
    staticClass: "gen txtClr",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" " + _vm._s(_vm.genders[(_vm$riderData = _vm.riderData) === null || _vm$riderData === void 0 ? void 0 : (_vm$riderData$user = _vm$riderData.user) === null || _vm$riderData$user === void 0 ? void 0 : _vm$riderData$user.userData["data"]["PlayerData"]["PlayerProfileStruct"]["Gender"]]) + " ")]), (_vm$riderData2 = _vm.riderData) !== null && _vm$riderData2 !== void 0 && (_vm$riderData2$user = _vm$riderData2.user) !== null && _vm$riderData2$user !== void 0 && _vm$riderData2$user.userData['data']['PlayerData']['PlayerProfileStruct']['PlayerCategoryId'] ? _c('a', {
    staticClass: "cat-list bgClrRed",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" CAT " + _vm._s((_vm$riderData3 = _vm.riderData) === null || _vm$riderData3 === void 0 ? void 0 : (_vm$riderData3$user = _vm$riderData3.user) === null || _vm$riderData3$user === void 0 ? void 0 : _vm$riderData3$user.userData["data"]["PlayerData"]["PlayerProfileStruct"]["PlayerCategoryId"]) + " ")]) : _vm._e(), _c('button', {
    staticClass: "btnCircle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('download-file', _vm.selectedFileId);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/activities/downloadCircle.png"
    }
  })])])])]), _c('div', {
    staticClass: "info-align"
  }, [_c('div', {
    staticClass: "row d-flex align-items-center"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-6"
  }, [_c('div', {
    staticClass: "info-activ-person d-flex justify-content-start align-items-end",
    staticStyle: {
      "display": "none !important"
    }
  }, [_c('div', [_vm._v(_vm._s((_vm$singleRideData7 = _vm.singleRideData) === null || _vm$singleRideData7 === void 0 ? void 0 : _vm$singleRideData7.header_detail["elevation"]) + " m")]), _c('div', [_vm._v(_vm._s((_vm$singleRideData8 = _vm.singleRideData) === null || _vm$singleRideData8 === void 0 ? void 0 : _vm$singleRideData8.header_detail["distance"]) + " KM")]), _c('div', [_vm._v(_vm._s((_vm$singleRideData9 = _vm.singleRideData) === null || _vm$singleRideData9 === void 0 ? void 0 : _vm$singleRideData9.header_detail["watt"]) + " w")]), _c('div', [_vm._v(_vm._s((_vm$singleRideData0 = _vm.singleRideData) === null || _vm$singleRideData0 === void 0 ? void 0 : _vm$singleRideData0.header_detail["wattPerKg"]) + " w/KG")]), _c('div', [_vm._v(_vm._s((_vm$singleRideData1 = _vm.singleRideData) === null || _vm$singleRideData1 === void 0 ? void 0 : _vm$singleRideData1.header_detail["heartrate"]) + " BPM")]), _c('div', [_vm._v(_vm._s((_vm$singleRideData10 = _vm.singleRideData) === null || _vm$singleRideData10 === void 0 ? void 0 : _vm$singleRideData10.header_detail["rideDuration"]))])])]), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-6"
  })])])]), _c('section', {
    staticClass: "graphWrpr"
  }, [_c('div', {
    staticClass: "container p-0 mb-5"
  }, [_c('div', {}, [_c('div', {
    staticClass: "time-row d-flex justify-content-between"
  }, [_c('span', {
    staticClass: "subgraph-title"
  }, [_vm._v("elevation map")]), _c('div', {
    staticClass: "time-note"
  }, [_vm._v("TIME " + _vm._s(_vm.hoverElevationDate))])]), _c('div', {
    staticClass: "grph-text d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "graph-box-wrpr"
  }, [_c('LineChartGenerator', {
    ref: "elevationGraph",
    staticClass: "overContainer",
    attrs: {
      "id": "elevationGraph",
      "height": 220,
      "chart-options": _vm.chartOptionsElevation,
      "chart-data": _vm.chartDataElevation
    }
  })], 1), _c('div', {
    staticClass: "value-text"
  }, [_c('div', {
    staticClass: "graphText",
    staticStyle: {
      "text-align": "center !important"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.hoverElevationTime) + " MIN")]), _c('p', [_vm._v(_vm._s(_vm.hoverElevation) + " KM")])])])])]), _c('div', {
    staticClass: "margin-left-right"
  }, [_c('div', {
    staticClass: "time-row d-flex justify-content-between"
  }, [_c('span', {
    staticClass: "subgraph-title"
  }, [_vm._v("Power")]), _c('span', [_vm._v(" AVG "), _c('strong', [_vm._v(" " + _vm._s(_vm.avgPower) + " w")]), _vm._v(" | MAX "), _c('strong', [_vm._v(" " + _vm._s(_vm.maxPower) + " w")]), _vm._v(" | MIN "), _c('strong', [_vm._v(" " + _vm._s(_vm.minPower) + " w")])])]), _c('div', {
    staticClass: "grph-text d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "graph-box-wrpr"
  }, [_c('LineChartGenerator', {
    ref: "powerGraph",
    staticClass: "overContainer",
    attrs: {
      "height": 220,
      "chart-options": _vm.chartOptionsPower,
      "chart-data": _vm.chartDataPower
    }
  })], 1), _c('div', {
    staticClass: "value-text"
  }, [_c('div', {
    staticClass: "graphText",
    staticStyle: {
      "text-align": "center !important"
    }
  }, [_vm._v(" " + _vm._s(_vm.hoverPower) + " "), _c('span', {
    staticClass: "txtClrBlack"
  }, [_vm._v("w")])])])])]), _c('div', {
    staticClass: "margin-left-right"
  }, [_c('div', {
    staticClass: "time-row d-flex justify-content-between"
  }, [_c('span', {
    staticClass: "subgraph-title"
  }, [_vm._v("Speed")]), _c('span', [_vm._v(" AVG "), _c('strong', [_vm._v(" " + _vm._s(_vm.avgSpeed) + " KM/H ")]), _vm._v(" | MAX "), _c('strong', [_vm._v(" " + _vm._s(_vm.maxSpeed) + " KM/H ")])])]), _c('div', {
    staticClass: "grph-text d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "graph-box-wrpr"
  }, [_c('LineChartGenerator', {
    ref: "speedGraph",
    staticClass: "overContainer",
    attrs: {
      "height": 220,
      "chart-options": _vm.chartOptionsSpeed,
      "chart-data": _vm.chartDataSpeed
    }
  })], 1), _c('div', {
    staticClass: "value-text"
  }, [_c('div', {
    staticClass: "graphText",
    staticStyle: {
      "text-align": "center !important"
    }
  }, [_vm._v(" " + _vm._s(_vm.hoverSpeed) + " KM/H ")])])])]), _c('div', {
    staticClass: "margin-left-right"
  }, [_c('div', {
    staticClass: "time-row d-flex justify-content-between"
  }, [_c('span', {
    staticClass: "subgraph-title"
  }, [_vm._v("Heart Rate")]), _c('span', [_vm._v(" AVG "), _c('strong', [_vm._v(" " + _vm._s(_vm.avgHeartRate) + " BPM")]), _vm._v(" | MAX "), _c('strong', [_vm._v(_vm._s(" " + _vm.maxHeartRate) + " BPM")]), _vm._v(" | MIN "), _c('strong', [_vm._v(" " + _vm._s(_vm.minHeartRate) + " BPM")])])]), _c('div', {
    staticClass: "grph-text d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "graph-box-wrpr"
  }, [_c('LineChartGenerator', {
    ref: "heartGraph",
    staticClass: "overContainer",
    attrs: {
      "height": 220,
      "chart-options": _vm.chartOptionsHeartRate,
      "chart-data": _vm.chartDataHeartRate
    }
  })], 1), _c('div', {
    staticClass: "value-text"
  }, [_c('div', {
    staticClass: "graphText",
    staticStyle: {
      "text-align": "center !important"
    }
  }, [_vm._v(" " + _vm._s(_vm.hoverHeartRate) + " "), _c('span', {
    staticClass: "txtClrBlack"
  }, [_vm._v("BPM")])])])])]), _c('div', {
    staticClass: "margin-left-right"
  }, [_c('div', {
    staticClass: "time-row d-flex justify-content-between"
  }, [_c('span', {
    staticClass: "subgraph-title"
  }, [_vm._v("Cadence")]), _c('span', [_vm._v(" AVG "), _c('strong', [_vm._v(_vm._s(_vm.avgCadence) + " RPM")]), _vm._v(" | MAX "), _c('strong', [_vm._v(" " + _vm._s(_vm.maxCadence) + " RPM")])])]), _c('div', {
    staticClass: "grph-text d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "graph-box-wrpr"
  }, [_c('LineChartGenerator', {
    ref: "cadenceGraph",
    staticClass: "overContainer",
    attrs: {
      "height": 220,
      "chart-options": _vm.chartOptionsCadence,
      "chart-data": _vm.chartDataCadence
    }
  })], 1), _c('div', {
    staticClass: "value-text"
  }, [_c('div', {
    staticClass: "graphText",
    staticStyle: {
      "text-align": "center !important"
    }
  }, [_vm._v(" " + _vm._s(_vm.hoverCadence) + " "), _c('span', {
    staticClass: "txtClrBlack"
  }, [_vm._v("RPM")])])])])])])]), _c('br'), _c('br'), _c('br')]);
}
var staticRenderFns = []

export { render, staticRenderFns }